import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class CadastroUserTerceiroService {
  
  constructor(private http:HttpClient) { }

  salvaCadastro(data: any) {
    return this.http.post(API + '/employeeAdmin', data);
  }

  listarCadastroUser(data: any){
    return this.http.get(API + '/employeeAdmin/' + data);
  }

  editarCadastroUser(id: any, data: any){
    return this.http.put(API + '/employeeAdmin/' + id,  data);

  }

}
